import { ToggleOption } from '../../../../../../../../ui-components/lib/option.interface';

export const PLACEMENT_TYPE_VALUES = {
  DEPARTMENT_AND_JOB_TITLE: 'department_and_job_title',
  VACANT_POSITION: 'vacant_position',
  EXTERNAL: 'external',
} as const;

export type PlacementTypeValue =
  (typeof PLACEMENT_TYPE_VALUES)[keyof typeof PLACEMENT_TYPE_VALUES];

export const PLACEMENT_TYPE_OPTIONS: ToggleOption[] = [
  {
    value: PLACEMENT_TYPE_VALUES.DEPARTMENT_AND_JOB_TITLE,
    label: 'user_form_screen_placement_type_department_and_job_title_option',
  },
  {
    value: PLACEMENT_TYPE_VALUES.VACANT_POSITION,
    label: 'user_form_screen_placement_type_vacant_position_option',
  },
  {
    value: PLACEMENT_TYPE_VALUES.EXTERNAL,
    label: 'user_form_screen_placement_type_external_option',
  },
];
